import React, { useState } from "react";
import { Circle, Text } from "react-konva";
import { updatedPolygonCoordinates } from "../../../../Features/roofInfo";
import { useDispatch, useSelector } from "react-redux";

export default function Pointer({ stageRef, dragPos, zoomValue, setIsDrawing }) {
  const dispatch = useDispatch();
  const [angleUpdate, setAngleUpdate] = useState(false);
  const designParameter = useSelector((state) => state.designParameter);
  const quantityInfo = useSelector((state) => state.quantity)

  const polygonIndex = quantityInfo.roofNo;
  const roofInfo = useSelector((state) => state.roof);
  const [pointHover, setPointHover] = useState();

  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  let updatePoints =
    roofPolygons && roofPolygons.length > polygonIndex
      ? roofPolygons[polygonIndex].updatedPoints
      : [];
  var specificPoint;

  const handleChangePoint = (index) => {
    setIsDrawing(false)
    setAngleUpdate(true);
    specificPoint = stageRef.current.getPointerPosition();
    specificPoint = {
      x: (specificPoint.x - dragPos.x) / zoomValue,
      y: (specificPoint.y - dragPos.y) / zoomValue,
    };
    const updateList = [...updatePoints];
    updateList[index] = specificPoint;
    updatePoints = updateList;
    const updatedPolygon = [...roofPolygons];
    updatedPolygon[polygonIndex] = updateList;

    dispatch(
      updatedPolygonCoordinates({
        index: polygonIndex,
        value: { updatedPoints: updateList },
      })
    );
  };

  const handleUpdate = () => {
    const updatedPolygon = [...roofPolygons];
    updatedPolygon[polygonIndex] = updatePoints;
    dispatch(
      updatedPolygonCoordinates({
        index: polygonIndex,
        value: { updatedPoints: updatePoints },
      })
    );
    setAngleUpdate(false);
  };

  const removePoint = (point) => {
    if (updatePoints.length <= 3) {
      alert(
        "If the roof consists of three nodes, deletion or removal of any node is not permitted."
      );
      return false;
    }
    const updatedPoints = updatePoints.filter((item) => item !== point);
    updatePoints = updatedPoints;
    const updatedPolygon = [...roofPolygons];
    updatedPolygon[polygonIndex] = updatedPoints;
    dispatch(
      updatedPolygonCoordinates({
        index: polygonIndex,
        value: { updatedPoints: updatedPoints },
      })
    );
  };

  return updatePoints.map((point, index) => (
    <React.Fragment key={index}>
      {designParameter.polygonEdit && (
        <Circle
          x={point.x}
          y={point.y}
          radius={index === pointHover ? 6 : 4}
          fill="red"
          draggable
          onDblClick={() => {
            removePoint(point);
          }}
          onDragEnd={() => handleUpdate(index)}
          onDragMove={() => {
            handleChangePoint(index);
          }}
          onMouseEnter={() => {
            setIsDrawing(false)
            setPointHover(index)
          }}
          onMouseLeave={() => setPointHover()}
        />
      )}
      {angleUpdate && (
        <React.Fragment>
          <Text
            x={updatePoints[index].x + 4}
            y={updatePoints[index].y + 4}
            text={`${Rotation1(updatePoints[index], index, updatePoints)}°`}
            fontFamily="italic"
            fontSize={12}
            fill={"red"}
            strokeWidth={1}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  ));
}

function Rotation1(point1, index, updatedPoints) {
  let pointA;
  let pointB = point1;
  let pointC;
  if (index === 0) {
    pointA = updatedPoints[updatedPoints.length - 1];
  } else {
    pointA = updatedPoints[index - 1];
  }
  if (index === updatedPoints.length - 1) {
    pointC = updatedPoints[0];
  } else {
    pointC = updatedPoints[index + 1];
  }
  const abX = pointB.x - pointA.x;
  const abY = pointB.y - pointA.y;
  const bcX = pointC.x - pointB.x;
  const bcY = pointC.y - pointB.y;

  const dotProduct = abX * bcX + abY * bcY;
  const abMagnitude = Math.sqrt(abX * abX + abY * abY);
  const bcMagnitude = Math.sqrt(bcX * bcX + bcY * bcY);

  const angle = Math.acos(dotProduct / (abMagnitude * bcMagnitude));
  const value = Number(((angle * 180) / Math.PI).toFixed());

  return 180 - value;
}

